import AnalyticsRepository from "../../repository/AnalyticsRepository";
import { getMobileOS } from "./IdentityUtils";

export function sendPageView(analytics, pageName, additionalParameters) {
    const analyticsRepository = new AnalyticsRepository()
    analyticsRepository.sendPageView(pageName, getAnalyticsId(), getMobileOS(), additionalParameters)
    // logEvent(analytics, pageName, additionalParameters)
}

export function sendAction(analytics, actionName, pageName, additionalParameters) {
    const analyticsRepository = new AnalyticsRepository()
    analyticsRepository.sendAction(actionName, pageName, getAnalyticsId(), getMobileOS(), additionalParameters)
    // logEvent(analytics, actionName, additionalParameters)
}

const getAnalyticsId = () => {
    const cookie = document.cookie.match(/analytics_uid=([^;]+)/);
    if (cookie) return cookie[1];
    const id = crypto.randomUUID();
    document.cookie = `analytics_uid=${id};max-age=${730*24*60*60};path=/;SameSite=Lax;Secure`;
    return id;
};
